import React from 'react';
import Box from '@mui/material/Box';
import { CloseIcon } from '@/assets/images';

type CloseButtonProps = {
  closeToast: () => void;
};

function CloseButton({ closeToast }: CloseButtonProps) {
  return (
    <Box
      alignItems="center"
      className="cursor-pointer"
      data-testid="toast-feedback-close-button"
      display="flex"
      onClick={closeToast}
    >
      <CloseIcon />
    </Box>
  );
}

export default CloseButton;
